import React from "react";
import { useForm, useFormState } from "react-final-form";
import {
  Box,
  Button,
  Table,
  TableRow,
  TableCell,
  TableContainer,
  TableBody,
} from "@mui/material";
import { useSelector } from "react-redux";
import { dropdownopts, dropdownsloading, formState } from "../../features/AppSlice";
import {
  MenuItemsForDropDown,
  TaxTypeSelectComponent,
  TaxNumberComponent,
  RegisteredNameField,
  RegistrationNumberField,
} from "@soqs/common";
import SelectComponent from "./usercomponents/SelectComponent";
import EntityTypeSelectComponent from "./usercomponents/EntityTypeSelectComponent";
import PAYENumberComponent from "./usercomponents/PAYENumber/PAYENumberComponent";
import VATNumberComponent from "./usercomponents/VATNumber/VATNumberComponent";
import CompanyRegistrationNumberComponent from "./usercomponents/CompanyRegistrationNumber/CompanyRegistrationNumberComponent";
import BOEntityRepList from "./BOEntityRepList";
import {
  TaxType,
  EntityType,
  TrustType,
} from "@soqs/common";
import BODescription from "./usercomponents/BODescription";

const BOEntityDetails = (props) => {
  const dropdownloading = useSelector(dropdownsloading);
  const dropdownoptions = useSelector(dropdownopts);
  const formstate = useFormState();
  const formData = useSelector(formState);
  let form = useForm();

  const ResetTaxType = (newEntityType) => {
    const arrayCopy = {
      ...formstate.values.bo_entities[props.index],
    };
    arrayCopy.bo_entity_taxtype = TaxType.PIT;
    arrayCopy.bo_entity_type = newEntityType;
    form.mutators.update("bo_entities", props.index, arrayCopy);
  };

  return formData.values?.bo_entities[props.index].bo_entity_unnamed !==
  true ? (
    <>
      <Box sx={{ display: { xs: "block", md: "none" } }}>
        <Button>
          <u>{`Entity ${props.index + 1}`}</u>
        </Button>
        <SelectComponent
          label="Beneficial Ownership Type"
          name={`${props.name}.bo_entity_botype`}
          aria-label={`Entity ${props.index + 1}: Ownership Type`}
          required={true}
          options={MenuItemsForDropDown(
            "entitybeneficialownershiptype",
            dropdownoptions,
            false
          )}
          optionsloading={dropdownloading}
        />
        <EntityTypeSelectComponent
          label="Entity Type"
          name={`${props.name}.bo_entity_type`}
          aria-label={`Entity ${props.index + 1}: Entity Type`}
          required={true}
          taxoptions={MenuItemsForDropDown(
            "entitytype",
            dropdownoptions,
            false
          )}
          optionsloading={dropdownloading}
          onChange={(e) => {
            ResetTaxType(e.target.value);
          }}
        />
        <RegisteredNameField
          label="Registered Name"
          name={`${props.name}.bo_entity_registered_name`}
          aria-label={`Entity ${props.index + 1}: Registered Name`}
          required={true}
        />
        {formstate.values?.bo_entities[props.index].bo_entity_type ===
          EntityType.Company &&
        formstate.values?.trustType !== TrustType.Foreign ? (
          <CompanyRegistrationNumberComponent
            name={`${props.name}.bo_entity_registration_number`}
            aria-label={`Entity ${props.index + 1}: Registration Number`}
            required={(formstate.values?.trustType !== TrustType.Foreign)}
          />
        ) : formstate.values?.bo_entities[props.index].bo_entity_type !==
            EntityType.Other &&
          formstate.values?.trustType !== TrustType.Foreign ? (
          <RegistrationNumberField
            label="Registration Number"
            name={`${props.name}.bo_entity_registration_number`}
            aria-label={`Entity ${props.index + 1}: Registration Number`}
            required={true}
          />
        ) : null}
        {formstate.values?.bo_entities[props.index].bo_entity_type ===
        EntityType.Company ? (
          <TaxTypeSelectComponent
            name={`${props.name}.bo_entity_taxtype`}
            aria-label={`Entity ${props.index + 1}: Tax Type`}
            taxoptions={MenuItemsForDropDown(
              "taxtype_company",
              dropdownoptions,
              true
            )}
            optionsloading={dropdownloading}
          />
        ) : null}
        {formstate.values?.bo_entities[props.index].bo_entity_type ===
        EntityType.Trust ? (
          <TaxTypeSelectComponent
            name={`${props.name}.bo_entity_taxtype`}
            aria-label={`Entity ${props.index + 1}: Tax Type`}
            taxoptions={MenuItemsForDropDown(
              "taxtype_trust",
              dropdownoptions,
              true
            )}
            optionsloading={dropdownloading}
          />
        ) : null}
        {formstate.values?.bo_entities[props.index].bo_entity_type ===
        EntityType.Other ? (
          <TaxTypeSelectComponent
            name={`${props.name}.bo_entity_taxtype`}
            aria-label={`Entity ${props.index + 1}: Tax Type`}
            taxoptions={MenuItemsForDropDown(
              "taxtype_other",
              dropdownoptions,
              true
            )}
            optionsloading={dropdownloading}
          />
        ) : null}

        {formstate.values?.bo_entities[props.index].bo_entity_taxtype ===
        TaxType.PIT ? (
          <TaxNumberComponent
            name={`${props.name}.bo_entity_taxnumber`}
            aria-label={`Entity ${props.index + 1}: Income Tax Number`}
          />
        ) : null}
        {formstate.values?.bo_entities[props.index].bo_entity_taxtype ===
        TaxType.PAYE ? (
          <PAYENumberComponent
            name={`${props.name}.bo_entity_taxnumber`}
            aria-label={`Entity ${props.index + 1}: PAYE Number`}
          />
        ) : null}
        {formstate.values?.bo_entities[props.index].bo_entity_taxtype ===
        TaxType.VAT ? (
          <VATNumberComponent
            name={`${props.name}.bo_entity_taxnumber`}
            aria-label={`Entity ${props.index + 1}: VAT Number`}
          />
        ) : null}
        <br />
        <div>
          <BOEntityRepList index={props.index} />
        </div>
      </Box>

      <Box sx={{ display: { xs: "none", md: "block" } }}>
        <Button>
          <u>{`Entity ${props.index + 1}`}</u>
        </Button>
        <TableContainer>
          <Table sx={{ width: "100%" }}>
            <TableBody>
              <TableRow>
                <TableCell>
                  <SelectComponent
                    label="Beneficial Ownership Type"
                    name={`${props.name}.bo_entity_botype`}
                    aria-label={`Entity ${props.index + 1}: Entity Type`}
                    required={true}
                    options={MenuItemsForDropDown(
                      "entitybeneficialownershiptype",
                      dropdownoptions,
                      false
                    )}
                    optionsloading={dropdownloading}
                  />
                </TableCell>
                <TableCell>
                  <EntityTypeSelectComponent
                    label="Entity Type"
                    name={`${props.name}.bo_entity_type`}
                    aria-label={`Entity ${props.index + 1}: Entity Type`}
                    required={true}
                    taxoptions={MenuItemsForDropDown(
                      "entitytype",
                      dropdownoptions,
                      false
                    )}
                    optionsloading={dropdownloading}
                    onChange={(e) => {
                      ResetTaxType(e.target.value);
                    }}
                  />
                </TableCell>
                <TableCell>
                  <RegisteredNameField
                    label="Registered Name"
                    name={`${props.name}.bo_entity_registered_name`}
                    aria-label={`Entity ${props.index + 1}: Registered Name`}
                    required={true}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                {formstate.values?.bo_entities[props.index].bo_entity_type ===
                  EntityType.Company &&
                formstate.values?.trustType !== TrustType.Foreign ? (
                  <TableCell>
                    <CompanyRegistrationNumberComponent
                      name={`${props.name}.bo_entity_registration_number`}
                      aria-label={`Entity ${
                        props.index + 1
                      }: Registration Number`}
                      required={(formstate.values?.trustType !== TrustType.Foreign)}
                    />
                  </TableCell>
                ) : formstate.values?.bo_entities[props.index]
                    .bo_entity_type !== EntityType.Other &&
                  formstate.values?.trustType !== TrustType.Foreign ? (
                  <TableCell>
                    <RegistrationNumberField
                      label="Registration Number"
                      name={`${props.name}.bo_entity_registration_number`}
                      aria-label={`Entity ${
                        props.index + 1
                      }: Registration Number`}
                      required={true}
                    />
                  </TableCell>
                ) : null}

                <TableCell>
                  {formstate.values?.bo_entities[props.index].bo_entity_type ===
                  EntityType.Company ? (
                    <TaxTypeSelectComponent
                      name={`${props.name}.bo_entity_taxtype`}
                      aria-label={`Entity ${props.index + 1}: Tax Type`}
                      taxoptions={MenuItemsForDropDown(
                        "taxtype_company",
                        dropdownoptions,
                        true
                      )}
                      optionsloading={dropdownloading}
                    />
                  ) : null}
                  {formstate.values?.bo_entities[props.index].bo_entity_type ===
                  EntityType.Trust ? (
                    <TaxTypeSelectComponent
                      name={`${props.name}.bo_entity_taxtype`}
                      aria-label={`Entity ${props.index + 1}: Tax Type`}
                      taxoptions={MenuItemsForDropDown(
                        "taxtype_trust",
                        dropdownoptions,
                        true
                      )}
                      optionsloading={dropdownloading}
                    />
                  ) : null}
                  {formstate.values?.bo_entities[props.index].bo_entity_type ===
                  EntityType.Other ? (
                    <TaxTypeSelectComponent
                      name={`${props.name}.bo_entity_taxtype`}
                      aria-label={`Entity ${props.index + 1}: Tax Type`}
                      taxoptions={MenuItemsForDropDown(
                        "taxtype_other",
                        dropdownoptions,
                        true
                      )}
                      optionsloading={dropdownloading}
                    />
                  ) : null}
                </TableCell>
                <TableCell>
                  {formstate.values?.bo_entities[props.index]
                    .bo_entity_taxtype === TaxType.PIT ? (
                    <TaxNumberComponent
                      name={`${props.name}.bo_entity_taxnumber`}
                      aaria-label={`Entity ${
                        props.index + 1
                      }: Income Tax Number`}
                    />
                  ) : null}
                  {formstate.values?.bo_entities[props.index]
                    .bo_entity_taxtype === TaxType.PAYE ? (
                    <PAYENumberComponent
                      name={`${props.name}.bo_entity_taxnumber`}
                      aria-label={`Entity ${props.index + 1}: PAYE Number`}
                    />
                  ) : null}
                  {formstate.values?.bo_entities[props.index]
                    .bo_entity_taxtype === TaxType.VAT ? (
                    <VATNumberComponent
                      name={`${props.name}.bo_entity_taxnumber`}
                      aria-label={`Entity ${props.index + 1}: VAT Number`}
                    />
                  ) : null}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <br />
        <div>
          <BOEntityRepList index={props.index} />
        </div>
      </Box>
    </>
    //end if
    ) : (
      <>
        <Box sx={{ display: { xs: "block", md: "none" } }}>
          <Button>
            <u>{`Entity  ${props.index + 1} (UNNAMED)`}</u>
          </Button>
          <SelectComponent
          label="Beneficial Ownership Type"
          name={`${props.name}.bo_entity_botype`}
          aria-label={`Entity ${props.index + 1}: Ownership Type`}
          required={true}
          options={MenuItemsForDropDown(
            "entitybeneficialownershiptype",
            dropdownoptions,
            false
          )}
          optionsloading={dropdownloading}
        />
        <SelectComponent
          label="Beneficial Ownership Category"
          name={`${props.name}.bo_entity_unnamed_category`}
          aria-label={`Entity ${props.index + 1}: Entity Type`}
          required={true}
          options={MenuItemsForDropDown(
                   "bocategory",
                   dropdownoptions,
                   false
                  )}
         optionsloading={dropdownloading}
         />        
          <BODescription
            name={`${props.name}.bo_entity_unnamed_description`}
            aria-label={`Entity ${props.index + 1}: Description`}
            label="Description"
          />
        </Box>
        <Box sx={{ display: { xs: "none", md: "block" } }}>
          <TableContainer>
            <Table sx={{ width: "100%"}}>
              <TableBody>
                <TableRow>
                  <TableCell colSpan={12}>
                    <Button>
                      <u>{`Entity  ${props.index + 1} (UNAMED)`}</u>
                    </Button>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={6}>
                  <SelectComponent
                    label="Beneficial Ownership Type"
                    name={`${props.name}.bo_entity_botype`}
                    aria-label={`Entity ${props.index + 1}: Entity Type`}
                    required={true}
                    options={MenuItemsForDropDown(
                      "entitybeneficialownershiptype",
                      dropdownoptions,
                      false
                    )}
                    optionsloading={dropdownloading}
                  />
                  </TableCell>
                  <TableCell colSpan={6}>
                    <SelectComponent
                    label="Beneficial Ownership Category"
                    name={`${props.name}.bo_entity_unnamed_category`}
                    aria-label={`Entity ${props.index + 1}: Entity Type`}
                    required={true}
                    options={MenuItemsForDropDown(
                      "bocategory",
                      dropdownoptions,
                      false
                    )}
                    optionsloading={dropdownloading}
                  />
                  </TableCell>
                  </TableRow>
                  <TableRow>
                  <TableCell colSpan={12}>
                    <BODescription
                      name={`${props.name}.bo_entity_unnamed_description`}
                      aria-label={`Entity ${props.index + 1}: Description`}
                      label="Description"
                    />
                    </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <br />
        <div>
          <BOEntityRepList index={props.index} />
        </div>
        </Box>
      </>
    );
};

export default BOEntityDetails;
